import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../Layout';
import NonAuthLayout from 'Layout/NonAuthLayout';
import ErrorBoundary from 'Common/ErrorBoundary';

import { authProtectedRoutes } from "./allRoutes";
import { publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';

const Index = () => {
    return (
        <React.Fragment>
            {/* <Routes>
                <Route>
                    {authProtectedRoutes.map((route: any, idx: number) => (
                        <Route
                            key={idx}
                            path={route.path}
                            element={<Layout> {route.component} </Layout>}
                        // exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {publicRoutes.map((route: any, idx: number) => (
                        <Route
                            key={idx}
                            path={route.path}
                            element={<AuthProtected> <NonAuthLayout>{route.component}</NonAuthLayout> </AuthProtected>}
                        // exact={true}
                        />
                    ))}
                </Route>
            </Routes> */}
            <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={
              <NonAuthLayout> {route.component} </NonAuthLayout>}
              // exact={true}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected>
                  <ErrorBoundary>
                    <Layout>{route.component}</Layout>
                  </ErrorBoundary>
                </AuthProtected>
              }
              // exact={true}
            />
          ))}
        </Route>
      </Routes>
        </React.Fragment>
    );
}

export default Index;